import { render } from "./List.vue?vue&type=template&id=1c051a7b&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=1c051a7b&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1c051a7b"

export default script